import React from 'react'
import { Text, View, StyleSheet } from '@react-pdf/renderer'
import { Arced } from '../gauges/Arced'

const styles = StyleSheet.create({
  tableHeaderTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  tableHeaderTitleText1: {
    fontFamily: 'Inter',
    fontSize: 15,
    fontWeight: 500,
    marginRight: 5,
  }
});

const OverviewGaugesHealth = ({ coverData, categoriesData, uiData }) => {

  return (
    <>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          paddingLeft: '5%',
          paddingRight: '5%',
          paddingTop: 5,
          paddingBottom: 5,
          backgroundColor: 'rgb(226 232 240)',
        }}
      >
        <View style={styles.tableHeaderTitle}>
          <Text style={styles.tableHeaderTitleText1}>{uiData.features}</Text>
        </View>
      </View>

      <View
        style={{
          position: 'relative',
          paddingLeft: '5%',
          paddingRight: '5%',
          paddingTop: 20,
        }}
      >
        <View
          style={{
            backgroundColor: '#176b37',
            borderRadius: 5,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 20,
            color: '#fff',
            height: 160,
          }}
        >

          <View id='avgGauge' style={{ position: 'relative', width: 140, height: 140, overflow: 'visible' }}>
            <View>
              <Text
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  textAlign: 'center',
                  fontFamily: 'Inter',
                  fontSize: 30,
                  fontWeight: 700,
                }}
              >{coverData.avgPoint}</Text>
              <Arced value={coverData.avgPoint} color={'#fff'} />
            </View>
          </View>

          <View style={{ paddingLeft: 20 }}>
            <Text
              style={{
                fontFamily: 'Inter',
                fontSize: 18,
                fontWeight: 600,
                marginTop: 10,
                marginBottom: 10,
              }}
            >{uiData.average}</Text>
          </View>
        </View>

        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: 10,
            paddingTop: 15,
            paddingBottom: 15,
          }}
        >

          {categoriesData.map((entry, index) => {
            const isLastCard = index === categoriesData.length - 1; 
            return (
              <View key={entry.id} style={isLastCard ? { marginLeft: 'auto', marginRight: 'auto' } : {}}>
                <View
                  style={{
                    height: 120,
                    width: 262,
                    backgroundColor: '#fff',
                    padding: 5,
                    borderRadius: 5,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <View
                    style={{
                      position: 'relative',
                      width: '42%',
                      padding: 5,
                    }}
                  >
                    <Text
                      style={{
                        position: 'absolute',
                        bottom: 84,
                        left: 0,
                        right: 0,
                        textAlign: 'center',
                        fontFamily: 'Inter',
                        fontSize: 18,
                        fontWeight: 700,
                        zIndex: 100,
                      }}
                    >
                      {entry.points}
                    </Text>
                    <Arced value={entry.points} color={'#000'} />
                  </View>
                  <View
                    style={{
                      width: '58%',
                      paddingLeft: 10,
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Inter',
                        fontSize: 12,
                        fontWeight: 500,
                        maxWidth: '90%',
                      }}
                    >
                      {entry.name}
                    </Text>
                  </View>
                </View>
              </View>
            );
          })}


        </View>
      </View >
    </>
  )
}

export default OverviewGaugesHealth